import { NAME } from './constants';
import { router } from './router';
import { apiProvider } from './api';
import { PROrdersParts } from './parts';
import Select from './components/Select.vue';

export const PROrders = {
	name: NAME,
	router,
	apiProvider,
	PROrdersParts,
	components: {
		Select,
	},
};
